var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-form",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [!_vm.isPayment ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "max-h-80px",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.icone')
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "card-list-pix"
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner"
  }, [_c('div', {
    staticClass: "card-input"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" Valor: R$ " + _vm._s(_vm.numberToReal(_vm.valorPix, 2)) + " ")]), _c('h5', {
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" Benificiário: " + _vm._s(_vm.benificiario) + " ")]), _c('h5', {
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" Vencimento: " + _vm._s(_vm.formatDate(_vm.dataValidadePix)) + " ")]), _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('transition', {
    attrs: {
      "name": "shake",
      "mode": "out-in"
    }
  }, [_c('QrCodeVue', {
    attrs: {
      "value": _vm.qrCodPix,
      "size": "300"
    }
  })], 1)], 1), _c('button', {
    staticClass: "card-form__button",
    on: {
      "click": _vm.copyQrCode
    }
  }, [_vm._v(" Copiar código PIX ")])])])])]) : _vm._e(), _vm.isPayment ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "max-h-80px",
    attrs: {
      "alt": "Logo",
      "src": _vm.layoutConfig('self.logo.icone')
    }
  })]), _c('div', {
    staticClass: "card-list-pix",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('div', {
    staticClass: "card-form-assinatura__inner",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Check', {
    staticStyle: {
      "color": "green !important"
    },
    attrs: {
      "size": "100"
    }
  }), _c('div', {
    staticClass: "card-input"
  }, [_c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" Valor Pago: R$ " + _vm._s(_vm.numberToReal(_vm.paymentEvent.amount, 2)) + " ")]), _c('h5', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(" Data Pagamento: " + _vm._s(_vm.formatDate(_vm.paymentEvent.created_at)) + " ")]), _c('h5', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_vm._v(" Muito obrigado! ")])])], 1)])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "wizard-label",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('h4', {
    staticClass: "wizard-title",
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" Veja abaixo como realizar o pagamento do Pix. ")]), _c('p', {
    staticClass: "wizard-title",
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" 1 - Abra o app do seu banco ou instituição financeira e acesso ambiente do pix ")]), _c('p', {
    staticClass: "wizard-title",
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" 2 - Selecione a opção pagar com Qr Code e escanei o código abaixo ")]), _c('p', {
    staticClass: "wizard-title",
    staticStyle: {
      "text-align": "center",
      "color": "var(--primary-color)"
    }
  }, [_vm._v(" 3 - Confirme as informações e finalize o pagamento ")])]);
}];
export { render, staticRenderFns };